import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";

@Component({
    standalone: false,
    selector: 'app-validation-warnings-icon-cell-viewer',
  templateUrl: './validation-warnings-icon-cell-viewer.component.html',
  styleUrls: ['./validation-warnings-icon-cell-viewer.component.scss']
})
export class ValidationWarningsIconCellViewerComponent implements OnInit, CellComponent{
  sourceType?: string;
  valueChanged?: EventEmitter<any>;
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  displayText: string;
  disabled: boolean;



  constructor() { }

  ngOnInit(): void {}
}
